import React from "react";
import { Trans, t } from "app/utils";
import { Tooltip } from "@culturehq/components";

const MENTION_REGEX = /@\[.*?\]\(.*?\)/g; // @[Josué Santamaria](urn:li:person:DpId_d_Poi)

const parseMentions = (value = "") => {
  const matches = value?.match(MENTION_REGEX);

  if (!matches?.length) return value;

  const elements = [];
  let lastIndex = 0;

  matches.forEach((match, index) => {
    let [mentionName] = match.match(/\[.+?\]/g) || [];
    mentionName = mentionName.replace(/[[\]]/g, "");

    const startIndex = value.indexOf(match, lastIndex);
    const beforeMatch = value.substring(lastIndex, startIndex);

    if (beforeMatch) {
      elements.push(beforeMatch);
    }

    elements.push(
      <Tooltip bottom key={index} tip={t("View the post on LinkedIn to be directed to this mention.")}>
        <span className="LinkedinEngageMention">{mentionName}</span>
      </Tooltip>
    );

    lastIndex = startIndex + match.length;
  });

  const afterLastMatch = value.substring(lastIndex);
  if (afterLastMatch) {
    elements.push(afterLastMatch);
  }

  return elements;
};


const LinkedinMentionText = ({ value }) => (
  <span><Trans>{parseMentions(value)}</Trans></span>
);

export default LinkedinMentionText;
